<template>
    <!--故障视图-->
    <div class="fault-wrap">
        <!--主地图-->
        <div id="faultmap" class="t-map"></div>
        <div class="fault-history" v-if="!historyMode" @click="openHistoryFaultData">
            <i class="iconfont">&#xe60c;</i>
        </div>
        <!--显示故障列表-->
        <div class="fault-table" v-if="historyMode">
            <div class="close" @click="closeHistoryFaultData">
                <i class="iconfont">&#xe618;</i>
            </div>
            <el-table ref="faultTable" class="fault-content"
                :data="faultDataList"
                border
                max-height="300"
                style="width: 100%"
                highlight-current-row
                @row-click="faultTableClick">
                <el-table-column
                    label="颜色"
                    width="80">
                    <template slot-scope="scope">
                        <div :style="{background:scope.row.color}" class="color"></div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="title"
                    label="报警内容">
                </el-table-column>
                <el-table-column
                    prop="starttime"
                    label="开始时间"
                    :formatter="formatterTableColumn"
                >
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import TMap from "@components/TMap";
import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import {createEmpty,extend as Extentd} from 'ol/extent';
// import Feature from 'ol/Feature';

import {getUserSetting,getPipelinelayer,pipelineFaultData} from "@api/map2d";

export default {
    name:"fault",
    data(){
        return {
            mainmap:null,// 主地图

            pipelineConfig:null, // 管线配置
            pipelineLayerData:null, //管道的GeoJSON数据
            pipelineFeatureArray:null, //管道feature数据

            currentTimeId:null, // 定时器获取管道的故障数据
            featureColorFlag:false, // 管道颜色
            faultFeatureArray:[], // 报警管道

            faultDataList:[],// 故障列表
            historyMode:false, //历史记录是否开启
        }
    },
    mounted(){
        this.$nextTick(()=>{
            // 加载地图
            let tmap=new TMap("faultmap",{
                center:[120.349,30.34],
                level:18,
                option:{
                    zoomSlider:true // 显示zoomSlider
                }
            });
            this.mainmap=tmap;

            // 初始化管道数据
            this.initConfig();
        });
    },
    methods:{
        // 初始化用户配置
        async initConfig(){
            // 获取管线的线段配置
            let pipedata=await getUserSetting("pipeline");
            if(pipedata.status!=200||!pipedata.content||Object.keys(pipedata.content).length<=0){
                this.pipelineConfig=null;
                return;
            }
            let pipelineConfig=pipedata.content;
            //构建线段的配置对象
            /* 根据线段的配置文件，最后组装成了这个对象
            {
                "id": 2,
                "linenumber": 2,
                "startnumber": 389,  //线段开始编号
                "endnumber": 599,
                "sublineArray":[
                    {
                    "startnumber": 155,
                    "endnumber": 378,
                    "dindex": 8
                    },
                    {
                    "startnumber": 155,
                    "endnumber": 378,
                    "dindex": 8
                    }
                ]
            }
            */
            let lineConfig={}; //管线配置数据
            if(pipelineConfig.length>0){
                var tempLength=0;
                var lineCount=pipelineConfig.length;
                for(var i=0;i<lineCount;i++){
                    var temp=pipelineConfig[i];
                    if(!lineConfig[temp.lineId]){
                        lineConfig[temp.lineId]=temp;
                        lineConfig[temp.lineId].sublineArray=[];
                    }
                    //构建子数组
                    var subTemp={
                        "startIndex": temp.startIndex,
                        "endIndex":  temp.endIndex,
                        "dindex": tempLength
                    }
                    lineConfig[temp.lineId].sublineArray.push(subTemp);
                    tempLength+=temp.endIndex-temp.startIndex+1;
                }
            }
            // 保存构建的数组
            this.pipelineConfig=lineConfig;


            // 获取管线图层数据
            await this.getPipelinelayer();
        },
        // 获取管线图层数据
        async getPipelinelayer(){
            let that=this;
            await getPipelinelayer().then(data=>{
                // 判断是否数据正常
                if(!data||!data.features||data.features.length<=0){
                    return;
                }
                this.pipelineLayerData=data;


                // 加载管线数据
                let geojsonFormat=new GeoJSON();
                let features=geojsonFormat.readFeatures(data);
                //将请求结果保存
                that.pipelineFeatureArray=features;

                //获取管线的故障数据
                that.getPipelineFaultData();

                //绘制图层
                let vectorSource = new VectorSource({
                    format: new GeoJSON(),
                });
                vectorSource.addFeatures(features);
                let vector = new VectorLayer({
                    name:"pipeline_layer",
                    source: vectorSource,
                    zIndex:200,
                    minResolution:that.mainmap.getResolution(20),
                    maxResolution:that.mainmap.getResolution(10),
                    style:new Style({
                        stroke: new Stroke({
                            lineCap:"square",
                            width:5,
                            color:"#949494"
                        })
                    })
                });
                // 将图层添加到底图上
                that.mainmap.addLayer(vector);

                //获取管线范围
                let extent=createEmpty();
                let featureArray=features;
                for(let i=featureArray.length-1;i>=0;i--){
                    let feature=featureArray[i];
                    //存储图形的范围
                    let geom=feature.getGeometry();
                    extent=Extentd(extent,geom.getExtent());
                }
                //保存图形范围
                that.featureExtent=extent;
                let [x1,y1,x2,y2]=extent;
                that.featureExtent=[x1-0.01,y1-0.01,x2+0.01,y2+0.01];
                //图形缩放到全屏
                that.mainmap.getView().fit(that.featureExtent,that.mainmap.getSize());
            });
        },

        // 获取实时数据
        timingDrawData(){
            let that=this;
            // 清空定时器
            if(that.currentTimeId){
                clearTimeout(that.currentTimeId);
                that.currentTimeId=null;
            }
            // 判断当前路由是否为智慧管网，如果不是，则应该取消定时器
            if(this.$route.name!="fault"){
                // 取消定时器
                if(that.currentTimeId){
                    clearTimeout(that.currentTimeId);
                    that.currentTimeId=null;
                }
                return;
            }
            that.currentTimeId=setTimeout(async function(){
                // 定时器调用实时数据
                if(that.currentTimeId){
                    clearTimeout(that.currentTimeId);
                    that.currentTimeId=null;

                    // 获取实时数据
                    that.featureAnimationFrame();

                    // 重启定时器
                    that.timingDrawData();
                }else{
                    // 获取实时数据
                    that.featureAnimationFrame();

                    // 重启定时器
                    that.timingDrawData();
                }
            },2*1000);
        },

        // 获取故障数据
        getPipelineFaultData(){
            let that=this;
            // 获取管道的故障数据
            pipelineFaultData().then(data=>{
                if(data.status==200){
                    let content=data.content;
                    that.faultDataList=content;

                    let faultD=content[0]; // 第一条故障数据
                    
                    // 显示通知
                    this.$notify({
                        title: '故障报警',
                        type: 'warning',
                        dangerouslyUseHTMLString: true,
                        message:'<div class="fault-message">'+
                                '<div class="item">'+
                                    '<span class="label">警示色:</span>'+
                                    '<span class="color" style="display:inline-block;background:'+faultD.color+';width:60px;height:10px;"></span>'+
                                '</div>'+
                                '<div class="item">'+
                                    '<span class="label">开始时间:</span>'+
                                    '<span>'+faultD.starttime+'</span>'+
                                '</div>'+
                                '<div class="item">'+
                                    '<span class="label">详情:</span>'+
                                    '<span>'+faultD.title+'</span>'+
                                '</div>'+
                                '<div class="item">'+
                                    '<span class="label">区间:</span>'+
                                    '<span>'+faultD.startindex+"——"+faultD.endindex+'</span>'+
                                '</div>'+
                            '</div>',
                        duration: 0
                    });

                    // 绘制管道样式
                    that.pipelineDrawFault(faultD);
                }

            })
        },
        // 计算管道样式
        pipelineDrawFault(data){
            let that=this;
            let startFault=data.startindex; // 异常数据开始编号
            let endFault=data.endindex; // 异常数据结束编号
            let colorFault=data.color;// 异常数据颜色
            //遍历所有的线段,获取线段编号，然后根据线段编号从线段配置文件中读取相应的数据，根据起始和终点相减获取到数据长度，然后在实时数据中取相应的长度数据对应
            let featureArray=that.pipelineFeatureArray;
            that.faultFeatureArray=[]; // 清空数组 
            for(let i=featureArray.length-1;i>=0;i--){
                let feature=featureArray[i];

                let featureProperties=feature.getProperties();
                // 获取线段编号
                let linenumber=featureProperties.number;
                // 管线配置不存在
                if(!that.pipelineConfig){
                    break;
                }
                let lineConfig=that.pipelineConfig[linenumber];
                //如果线段中有配置项，则根据配置项进行绘制
                if(lineConfig){
                    // 子编号在线段的配置文件里面，则获取数据
                    let subNumber=featureProperties.subnumber;
                    let sublineArray=lineConfig.sublineArray;
                    for(let j=sublineArray.length-1;j>=0;j--){
                        let subLineConfig=sublineArray[j];
                        let startNumber=subLineConfig.startIndex;
                        let endNumber=subLineConfig.endIndex;
                        if(subNumber>=startNumber&&subNumber<=endNumber){
                            // 获取每一段地图上的管线对应的管线实时数据的偏移量
                            // 偏移量=当前线段的子编号-线段配置文件中的开始编号+线段配置文件中的数据开始偏移量
                            let offsetIndex=subNumber-startNumber+subLineConfig.dindex;
                            if(offsetIndex>=startFault&&offsetIndex<=endFault){
                                //获取到真实数据后，根据数据绘制内容
                                feature.set("realdata",colorFault);
                                feature.setStyle(that.pipelineStyleFun(feature));
                                // 保存报警管道
                                that.faultFeatureArray.push(feature);
                            }

                        }
                    }
                }
            }
            // 启动动画
            that.timingDrawData();
        },
        //绘制管线样式
        pipelineStyleFun(feature,auto) {
             let featureProperties=feature.getProperties();
            //根据当前配置项，显示数据
            let currentValue=featureProperties.realdata;
            if(auto){
                if(!currentValue){
                    currentValue="#949494" ;
                }
            }else{
                currentValue="#949494" ;
            }

            let style=new Style({
                stroke: new Stroke({
                    color: currentValue,
                    width:5,
                    lineCap:"square"
                })
            });
            return style;
        },

        // 开启定时动画
        featureAnimationFrame(){
            this.featureColorFlag=!this.featureColorFlag;
            let featureArray=this.faultFeatureArray;
            for(let i=featureArray.length-1;i>=0;i--){
                let feature=featureArray[i];
                feature.setStyle(this.pipelineStyleFun(feature,this.featureColorFlag));
            }
        },
        // 格式化table列
        formatterTableColumn(row,column,cellValue){
            return cellValue.replace(" ","\n"); 
        },
        // 故障列表点击
        faultTableClick(row){
            this.featureColorFlag=!this.featureColorFlag;

            // 清空管线上的原有的样式
            let featureArray=this.faultFeatureArray;
            for(let i=featureArray.length-1;i>=0;i--){
                let feature=featureArray[i];
                feature.set("realdata","");
                feature.setStyle(this.pipelineStyleFun(feature));
            }
            // 绘制管道样式
            this.pipelineDrawFault(row);
        },

        // 打开历史记录
        openHistoryFaultData(){
            this.historyMode=true;
            // 高亮第一行
            if( this.$refs.faultTable){
                let faultD=this.faultDataList; // 第一条故障数据
                this.$refs.faultTable.setCurrentRow(faultD);
            }

        },
        // 关闭历史记录
        closeHistoryFaultData(){
            this.historyMode=false;
        }
    },
}
</script>
<style lang="scss">
.fault-wrap{
    width:100%;
    height: 100%;

     /*地图放大缩小和比例尺*/
  .t-map {
      z-index: 0;
      width: 100%;
      height: 100%;
      position: fixed;
      background: #fff;

      .ol-zoom {
        position: absolute;
        left: .5em;
        z-index: 100;

        .ol-zoom-in{
          top: 60px;
          position:absolute;
          border-radius: 4px;
        }

        .ol-zoom-out{
          top:290px;
          position:absolute;
          border-radius: 4px;
        }
    }

    /** 滑动条 */
    .ol-zoomslider{
      top: 95px;
      width: 8px;
      left: 20px;
      left: 16px;
      background: #fff;
      border: 1px solid #afaeae;

      button{
        transform: translateX(-10px);
      }
    }
    .ol-control button {
        background: #fff;
        color: #000;
        margin: 0;
        font-size: 1rem;
        cursor: pointer;
        border: 1px solid #2aade4;
        outline: none;
    }
    .ol-touch .ol-control button{
        font-size:1.5rem;
    }

    .ol-control .zoom-bar-in {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom: 1px solid #aaa;
    }

    .ol-control .zoom-bar-out {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
  }

  .fault-table{
        max-width: 500px;
        min-width: 350px;
        position:fixed;
        bottom:10px;
        right: 20px;
        // 单元格内容居中
        .el-table td,.el-table th {
            text-align: center !important;
        }

        /** 时间列的单独配置 */
        .el-table .cell{
            word-break:initial;
            white-space: pre;
        }

        .color{
            width:60px;
            height: 10px;
        }

        .close{
            position: absolute;
            z-index: 10;
            right: -10px;
            top: -30px;
            background: #fff;
            padding: 10px;
            border-radius: 30px;
            cursor: pointer;
        }
  }
  .fault-history{
        position: fixed;
        right: 10px;
        bottom: 20px;
        width: 40px;
        height: 40px;
        background: #fff;
        color: #2aade4;
        border-radius: 30px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;

        i{
            font-size: 25px;
        }
  }
}

.fault-message{
    .label{
        font-weight: 600;
        font-size: 15px;
    }
}
</style>